unit UAbwHelper;

interface

uses
  UFeiertagList, UColorConfig, UTagKzList;

type
  TMonthModel = class
  private
    FJahr: Integer;
    FMonat: Integer;
    FStartIndex: Integer;
    FAnzTage: Integer;
    FFeiertagList: TFeiertagList;
    FColorConfig: TColorConfig;
    FTagKzList: TTagKzList;
    procedure SetJahr(const Value: Integer);
    procedure SetMonat(const Value: Integer);
    procedure SetColorConfig(const Value: TColorConfig);
  public
    constructor Create(monat, jahr: Integer; feiertagList: TFeiertagList;
      colorConfig: TColorConfig; tagKzList: TTagKzList);
    function IndexToStr(index: Integer): string;
    function IndexToTag(index: Integer): Integer;
    property Monat: Integer read FMonat write SetMonat;
    property Jahr: Integer read FJahr write SetJahr;
    property StartIndex: Integer read FStartIndex;
    property AnzTage: Integer read FAnzTage;
    property FeiertagList: TFeiertagList read FFeiertagList;
    property ColorConfig: TColorConfig read FColorConfig write SetColorConfig;
    property TagKzList: TTagKzList read FTagKzList;
  end;

implementation

uses
  System.SysUtils, UEssentialHelper, System.DateUtils, UFeiertagModel, UTagKzModel;

{ TMonthModel }

constructor TMonthModel.Create(monat, jahr: Integer; feiertagList: TFeiertagList;
  colorConfig: TColorConfig; tagKzList: TTagKzList);
var helper: TDateTime;
    s: string;
begin
  Self.Monat:=monat;
  Self.Jahr:=jahr;
  Self.FFeiertagList:=feiertagList;
  Self.ColorConfig:=colorConfig;
  Self.FTagKzList:=tagKzList;
  s:=IntToStr(Self.Monat);
  if Length(s)=1 then
    s:='0'+s;
  s:='01.'+s+'.'+IntToStr(Self.Jahr);
  helper:=StrToDateTime(s);
  Self.FStartIndex:=IndexOfWeekDay(FormatDateTime('ddd',helper));
  Self.FAnzTage:=DaysInMonth(helper);
end;

function TMonthModel.IndexToStr(index: Integer): string;
var farbe, s, schriftfarbe: string;
    helper: TDateTime;
    feiertag: TFeiertagModel;
    tagKz: TTagKzModel;
begin
  feiertag:=nil;
  tagKz:=nil;
  schriftfarbe:='black';
  index:=index-Self.StartIndex;
  if index<0 then
    Result:=''
  else if (0<=index) and (index<Self.AnzTage) then
    Result:=IntToStr(index+1)
  else
    Result:='';
  farbe:='white';
  if Result<>'' then begin
    s:=IntToStr(index+1)+'.'+IntToStr(Self.Monat)+'.'+IntToStr(Self.Jahr);
    helper:=StrToDateTime(s);
    tagKz:=Self.TagKzList.GetItemByDatum(helper);
    if tagKz<>nil then begin
      farbe:=RgbColorToHtmlColor(tagKz.Farbe);
      schriftfarbe:=CalcFontColor(tagKz.Farbe);
      if not tagKz.Genehmigt then
        Result:=Result+' ?';
    end
    else begin
      s:=FormatDateTime('ddd',helper);
      if (s='Sa') or (s='So') then begin
        farbe:=RgbColorToHtmlColor(Self.ColorConfig.FeiertagColor);
        schriftfarbe:=CalcFontColor(Self.ColorConfig.FeiertagColor);
      end
      else begin
        feiertag:=Self.FeiertagList.GetItemByDatum(helper);
        if feiertag<>nil then
          if feiertag.Aktiv then begin
            farbe:=RgbColorToHtmlColor(Self.ColorConfig.FeiertagColor);
            schriftfarbe:=CalcFontColor(Self.ColorConfig.FeiertagColor);
          end
          else begin
            farbe:=RgbColorToHtmlColor(Self.ColorConfig.FeiertagNotActiveColor);
            schriftfarbe:=CalcFontColor(Self.ColorConfig.FeiertagNotActiveColor);
          end;
      end;
    end;
  end;
  Result:=AlignCenter(Result,farbe,schriftfarbe);
end;

function TMonthModel.IndexToTag(index: Integer): Integer;
begin
  index:=index-Self.StartIndex;
  if (0<=index) and (index<Self.AnzTage) then
    Result:=Index+1
  else
    Result:=-1;
end;

procedure TMonthModel.SetColorConfig(const Value: TColorConfig);
begin
  FColorConfig := Value;
end;

procedure TMonthModel.SetJahr(const Value: Integer);
begin
  FJahr := Value;
end;

procedure TMonthModel.SetMonat(const Value: Integer);
begin
  FMonat := Value;
end;

end.
